import { NavLink } from 'react-router-dom';
import styles from './LogoutBar.module.scss';

export default function LogoutBar() {
    return (
        <div className={styles.logoutBarContainer}>
            <div className={styles.logoutBarLinks}>
                <NavLink 
                        to={"https://dashboard.dotfoods.com/"}
                        className={styles.link}
                    > 
                        Dashboard
                </NavLink>
                <NavLink 
                        to={"https://help.dotfoods.com/"}
                        target='_blank'
                        className={styles.link}
                    > 
                        Dot Foods Help Center
                </NavLink>
                <NavLink 
                    to={"/logout"}
                    className={styles.link}
                > 
                    logout
                </NavLink>
            </div>
        </div>
    );
}